import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
export function AnnouncementBar() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="bg-blue-600 relative z-50" data-id="element-2587">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-center relative" data-id="element-2588">
        <a href="https://www.clay.com" target="_blank" rel="noopener noreferrer" className="text-white text-sm font-medium hover:text-blue-50 transition-colors flex items-center gap-1" data-id="element-2589">
          Announcing our partnership with Clay!{' '}
          <span aria-hidden="true" data-id="element-2590">&rarr;</span>
        </a>
        <button onClick={() => setIsVisible(false)} className="absolute right-4 text-white/80 hover:text-white transition-colors" aria-label="Dismiss" data-id="element-2591">
          <XIcon className="w-4 h-4" data-id="element-2592" />
        </button>
      </div>
    </div>;
}